import { useQuery } from "@tanstack/react-query";
import {
  AuthenticatorSetupDataDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_USERS } from "../../domain";

import { usersApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GENERATE_AUTHENTICATOR = "GENERATE_AUTHENTICATOR";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

const getAuthenticator = async (): Promise<AuthenticatorSetupDataDto> => {
  const response = await usersApi.usersControllerGenerateMfaAuthenticatorQr();

  return response.data;
};

export const useGetAuthenticator = (
  user: UserProfileDto | null,
): {
  authenticator?: AuthenticatorSetupDataDto;
  authenticatorEnabled: boolean;
  isSuccessGenerateAuthenticator: boolean;
  isPendingGenerateAuthenticator: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isSuccess, isPending } = useQuery({
    queryKey: [DOMAIN_USERS, ACTION_GENERATE_AUTHENTICATOR],
    queryFn: () => getAuthenticator(),
    select: (response) => response,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    authenticator: data,
    authenticatorEnabled: enabled,
    isSuccessGenerateAuthenticator: isSuccess,
    isPendingGenerateAuthenticator: isPending,
  };
};
